(function () {
  'use strict';

  var storageKey = 'city-optics-lead-intake-v1';
  var formStoragePrefix = 'city-optics-lead-intake-v2:';
  var enabledBranches = new Set(['penrith', 'nepean']);
  var enabledLeadForms = new Set([
    'home-featured-offer',
    'shopify-forms-home-offer',
    'penrith-limited-time-offer',
    'nepean-limited-time-offer'
  ]);

  function value(formData, names) {
    for (var index = 0; index < names.length; index += 1) {
      var found = formData.get(names[index]);
      if (typeof found === 'string' && found.trim()) return found.trim();
    }
    return '';
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    }
    return Date.now().toString(36) + '_' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  function formStorageKey(formId) {
    return formStoragePrefix + encodeURIComponent(String(formId || 'unknown'));
  }

  function removeMatchingStorage(payload) {
    try {
      if (payload.formId) window.sessionStorage.removeItem(formStorageKey(payload.formId));
      var legacy = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      if (legacy && legacy.eventId === payload.eventId) window.sessionStorage.removeItem(storageKey);
    } catch (_) {
      // Storage cleanup is best effort only.
    }
  }

  function captureSubmission(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'post') return;
    var formData = new FormData(form);
    if (value(formData, ['form_type']) !== 'contact') return;
    var leadForm = value(formData, ['contact[form]']);
    if (!enabledLeadForms.has(leadForm)) return;
    var branch = value(formData, ['contact[branch]']).toLowerCase();
    if (!enabledBranches.has(branch)) return;

    var nameInput = form.querySelector('[autocomplete="name"]');
    var bodyInput = form.querySelector('textarea[name^="contact["]');
    var payload = {
      eventId: randomId(),
      formId: form.id || value(formData, ['contact[source_label]']) || window.location.pathname,
      capturedAt: new Date().toISOString(),
      branch: branch,
      name: value(formData, ['contact[name]', 'contact[Name]']) || (nameInput ? nameInput.value.trim() : ''),
      email: value(formData, ['contact[email]']),
      phone: value(formData, ['contact[phone]', 'contact[Phone]']),
      message: value(formData, ['contact[body]']) || (bodyInput ? bodyInput.value.trim() : ''),
      form: leadForm,
      offer: value(formData, ['contact[offer]']),
      hasPrescription: value(formData, ['contact[hasPrescription]', 'prescription']),
      pagePath: window.location.pathname,
    };
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
      window.sessionStorage.setItem(formStorageKey(payload.formId), JSON.stringify(payload));
    } catch (_) {
      // Shopify's contact form and email delivery continue even when browser storage is unavailable.
    }
  }

  async function forwardConfirmedSubmission(forceConfirmed, confirmation) {
    var raw;
    try {
      raw = forceConfirmed && confirmation && confirmation.form_id
        ? window.sessionStorage.getItem(formStorageKey(confirmation.form_id))
        : window.sessionStorage.getItem(storageKey);
    } catch (_) {
      return;
    }
    if (!raw) return;

    var payload;
    try {
      payload = JSON.parse(raw);
    } catch (_) {
      return;
    }
    var capturedAt = Date.parse(payload.capturedAt || '');
    if (!Number.isFinite(capturedAt) || Date.now() - capturedAt > 15 * 60 * 1000 || !enabledBranches.has(payload.branch)) {
      removeMatchingStorage(payload);
      return;
    }
    if (!forceConfirmed && new URLSearchParams(window.location.search).get('contact_posted') !== 'true') return;

    try {
      var response = await fetch('/apps/lead-intake', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      });
      if (response.ok || (response.status >= 400 && response.status < 500 && response.status !== 429)) {
        removeMatchingStorage(payload);
      }
    } catch (_) {
      // Leave the short-lived pending event available for one retry on reload.
    }
  }

  document.addEventListener('submit', captureSubmission, true);
  document.addEventListener('city-optics:contact-confirmed', function (event) {
    forwardConfirmedSubmission(true, event.detail || {});
  });
  forwardConfirmedSubmission();
})();
